/**
 * Follow (migration 1058; PRD-tasks-asks-and-my-work FR-5): hear when a record
 * changes, with nothing owed. The same control on an item, a cycle, a track, a
 * session, a decision and a commitment; what a person follows is listed on My
 * work under Following.
 */
import { useEffect } from 'react';
import { Bell, BellRing } from 'lucide-react';
import { useWatchesStore, type FollowSubject } from '@/stores/prioritization/watchesStore';

export function FollowButton({ type, id, className = '', style }: {
  type: FollowSubject;
  id: string;
  /** The page's own button look (e.g. btnSecondary(...)); a plain outline otherwise. */
  className?: string;
  style?: React.CSSProperties;
}) {
  const following = useWatchesStore((s) => s.followed.has(`${type}:${id}`));
  const loaded = useWatchesStore((s) => s.followed.size > 0 || !s.loading);
  const fetchFollowing = useWatchesStore((s) => s.fetchFromSupabase);
  const follow = useWatchesStore((s) => s.follow);
  const unfollow = useWatchesStore((s) => s.unfollow);
  useEffect(() => { void fetchFollowing(); }, [fetchFollowing]);
  return (
    <button
      type="button"
      aria-pressed={following}
      disabled={!loaded}
      onClick={() => void (following ? unfollow(type, id) : follow(type, id))}
      title={following ? 'You hear when this changes. Stop following.' : 'Hear when this changes, with nothing owed.'}
      style={style}
      className={className || 'inline-flex items-center gap-1.5 px-3 py-1.5 text-sm border border-[var(--rule)] text-[var(--text-sec)] hover:text-[var(--text-pri)] hover:bg-[var(--hover-tint)]'}
    >
      {following ? <BellRing className="h-3.5 w-3.5" /> : <Bell className="h-3.5 w-3.5" />}
      {following ? 'Following' : 'Follow'}
    </button>
  );
}
